import React from 'react'
import Nav from '../Components/Nav'
import Footer from '../Components/Footer'
import { Outlet } from 'react-router-dom'

export default function MainLayout() {
  return (
    <div>
        <Nav />
        <Outlet />
        <Footer />
    </div>
  )
}
